module.exports = __webpack_public_path__ + "img/bcc070.2932cd06.jpeg";